import './style.css'

const Error = (props:any) => {
  return (
    <div>
      <div id="notfound">
        <div className="notfound">
          <div className="notfound-404">
            <h1>Oops!</h1>
            <h2>{ props.message === '' ? 'Referencia no ingresada': props.message }</h2>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Error
